<template>
  <div>
    <i class="fas fa-circle" v-if="params.value !== '0'" :class="pdrClass"></i>
    <span v-if="params.value !== 0">{{ pdrStatus }}</span>
  </div>
</template>

<script>
export default {
  name: 'pdrStatusRenderer',
  computed: {
    pdrStatus () {
      return this.$lang.PCI.PDR.Status['_' + this.params.value]
    },
    pdrClass () {
      return {
        'rejected': this.params.value === '-1',
        'released': this.params.value === '1',
        'authorized': this.params.value === '2',
        'final-analises': this.params.value === '10',
        'analyzed': this.params.value === 9 || this.params.value === '11',
        'technical-director': this.params.value === '12',
        'rejected-tec-director': this.params.value === '13',
        'administrative-director': this.params.value === '14',
        'paralyzed': this.params.value === '15',
        'rated': this.params.value === '20' || this.params.value === '22',
        'na': this.params.value === '#NA#'
      }
    }
  }
}
</script>

<style scoped>
  .fas {
    font-size: 15px;
    text-shadow: -1px 1px 2px black;
  }

  .released {color: yellow;}
  .authorized { color: orange; }
  .rated { color: green; }
  .rejected, .rejected-tec-director { color: red; }
  .final-analises { color: darkviolet; }
  .analyzed { color: magenta; }
  .technical-director { color: gray; }
  .administrative-director { color: blue; }
  .paralyzed { color: black; }
  .na { color: white; }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/PdrStatusRenderer.vue